module.exports = exports = require('./ArrayUtils');


exports.getEquallySpacedData = require('./getEquallySpaced').getEquallySpacedData;
exports.SNV = require('./snv').SNV;



//////////////////
// WEBPACK FOOTER
// ./~/ml-array-utils/src/index.js
// module id = 3
// module chunks = 0